<script>
import axios from "axios";

export default {
  name: "SingleChatWrapper",
  data() {
    return {
      current_page: 1,
      chat: [],
      chatUser: [],
      usersInChat: [],
      pagination: [],
      chatMessages: [],
      response: null,
      last_message: null, // use on single chat template to scroll to it after load messages
    }
  },
  props: {
    slug: {
      default: null,
    },
  },
  methods: {
    async changePage(page) {
      this.current_page = page
      await this.setChatMessage()
      this.$emit("current_page", page);
    },
    addMessages(messages, isNew = true) {
      let currentMessages = this.chatMessages;
      messages.forEach(item => {
        if (isNew) {
          currentMessages.push(item)
        } else {
          currentMessages.unshift(item)
        }
      })
    },
    async setChatMessage() {
      const chatToken = localStorage.getItem('chat_token');
      const form = {page: this.current_page, slug: this.slug, chat_token: chatToken, withoutState: true}
      let res = await this.$store.dispatch('Chat/getSingleChat', form)
      const data = res.data.data;
      this.response = data
      this.chat = data.chat
      this.usersInChat = data.chat.user_chat
      this.chatUser = data.user
      this.pagination = data.meta
      this.last_message = data.data[0]
      this.addMessages(data.data, false)
    },
    async init() {
      await this.setChatMessage()
      await this.$emit('dataReady', this.response)
    },
    async sendMessage(form) {
      const res = await this.$store.dispatch('Chat/sendMessage', form);
      const message = res.data.data.data;
      const messages = [message]
      this.addMessages(messages, true)
      return res
    },
  },
  render() {

    return this.$slots.default({
      chat: this.chat,
      usersInChat: this.usersInChat,
      chatUser: this.chatUser,
      messages: this.chatMessages,
      pagination: this.pagination,
      changePageFunction: this.changePage,
      current_page: this.current_page,
    });

  },
  async mounted() {
    await this.init()
  }
}
</script>
